import React, { useState, useEffect, useMemo, useContext } from "react";
import { useNavigate } from "react-router-dom";

import CustomButton from "../components/kits/custom-button/CustomButton";
import OrdersSection from "../components/orders/OrdersSection";

import { ArrowRightIcon } from "../components/kits/Icons/Icons";

import ColorSchema from "../assets/kits/colors";

import { pathMaker } from "../utilities/helperFunctions";

import useAxios from "../services/useAxios";

import { ApiResponseType } from "../types/orders";

import Loader from "../components/kits/Loader";

import ShoppingCartItemContext from "../context/ShoppingCart/ShoppingCartItemContext";
import {getBoxByPosition} from "../utilities/apiTools";
import BoxSlider from "../components/common/slider/BoxSlider";

type OrderItemDetailType = {
  id: number;
  title: string;
  item_count: number;
  total_amount: number;
  price: number;
  discount: number;
  image_src: string;
};

type OrderDetailType = {
  id: number;
  supplier_title: string;
  supplier_id: number;
  mtm: number;
  status: number;
  delivery_cost: number;
  total_amount: number;
  total_discount: number;
  items: OrderItemDetailType[];
};

const OrdersPage: React.FC = () => {
  const nav = useNavigate();

  const { loading, execute: get_order } = useAxios("api/get_order");

  const { updateShoppingList } = useContext(ShoppingCartItemContext);
  const [unfinishedOrders, setUnfinishedOrders] = useState<OrderDetailType[]>(
    []
  );
  const [finishedOrders, setFinishedOrders] = useState<OrderDetailType[]>([]);


  useEffect(() => {
    get_order().then((res: { orders: ApiResponseType }) => {
      console.log("order ***", res);
      let result = res.orders.successful.map<OrderDetailType>((val) => ({
        id: +val.id,
        supplier_title: val.suplier_info.title,
        supplier_id: val.suplier_info.id,
        mtm: +val.mtm * 1000,
        status: +val.lats_order_status, // 2 => unfinished, 4 => finished
        total_amount: +val.total_price,
        total_discount: +val.total_discount,
        delivery_cost: +val.delivery_price,
        items: val.items.map<OrderItemDetailType>((v) => ({
          id: +v.avb_product_for_order__id,
          title: v.product_info.title,
          item_count: +v.item_count,
          total_amount: (+v.product_price - +v.discount) * +v.item_count,
          price: +v.product_price,
          discount: +v.discount,
          image_src: pathMaker(
            // typeof v?.img_cover_file?.path !== "undefined" && v?.img_cover_file?.path !== "" ? v?.img_cover_file?.path : v?.img_cover_file?.path
            v?.img_cover_file?.path
          ),
        })),
      }));
      if (result) updateShoppingList();

      let theFinishedOrders: OrderDetailType[] = [],
        theUnfinishedOrders: OrderDetailType[] = [];

      console.log(result.map((v) => v.status));
      result.forEach((v) => {
        if (v.status === 2) {
          theUnfinishedOrders.push(v);
        } else if (+v.status === 4) {
          theFinishedOrders.push(v);
        }
      });

      setFinishedOrders(
        theFinishedOrders.sort((a, b) => {
          return b.mtm - a.mtm;
        })
      );
      setUnfinishedOrders(
        theUnfinishedOrders.sort((a, b) => {
          return b.mtm - a.mtm;
        })
      );
    });
  }, []);


  return loading ? (
    <div className="d-flex align-items-center justify-content-center h-100">
      <Loader width={40} />
    </div>
  ) : (
    <div className="orders-page pd-b-12">
      <div className="d-flex pd-x-20 pd-y-12">
        <CustomButton
          className="pd-0"
          icon={
            <ArrowRightIcon
              color={ColorSchema.foreground_background_he}
              width={24}
            />
          }
          iconPosition="center"
          onClick={() => {
            nav(-1);
          }}
        />
        <h2 className="title-h3-b mr-r-8">سفارش‌ها</h2>
      </div>
      <div>

        {finishedOrders.length !== 0 || unfinishedOrders.length !== 0 ? (
          <OrdersSection
            unfinishedOrders={unfinishedOrders}
            finishedOrders={finishedOrders}
          />
        ) : (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: 254,
            }}
          >
            {/* <div
              style={{ backgroundColor: "#d9d9d9", width: 149, height: 119 }}
            /> */}
            <p className="txt-t2-l mr-y-24" style={{ color: "#000000" }}>
              تاکنون سفارشی ثبت نکرده‌اید. فروشگاه‌های اطراف خود را مشاهده کنید
              و سفارش دهید.
            </p>
            <CustomButton
              buttonStyle="primary"
              size="large"
              onClick={() => {
                nav("/");
              }}
            >
              فروشگاه‌های اطراف من
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersPage;
export type { OrderDetailType, OrderItemDetailType };
